import Backbone from 'backbone'

/**
 * A Rollup Tree Group
 */
const RollupTreeGroup = Backbone.Model.extend({

	domainType: 'rollup-tree-group',

	urlRoot: function() {
		return `api/dataset-trees/${this.get('treeRootId')}/rollup-tree-groups`
	}
})

export default RollupTreeGroup

RollupTreeGroup.__filename__ = 'admin/datasets/rollup-tree-group.js'
